import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "*",
        redirect: { name: "Error", params: { code: 404 } },
        meta: { requiresAuth: false, roles: [] },
    },
    {
        path: "/error/:code",
        name: "Error",
        meta: { requiresAuth: false, roles: [] },
        component: () =>
            import ("@/views/Errors/Error.vue"),
    },
    {
        path: "/",
        name: "Index",
        redirect: { name: "Login" },
        component: () =>
            import ("@/views/Index.vue"),
        meta: { requiresAuth: false, roles: [] },
        children: [{
                path: "/iniciarsesion",
                name: "Login",
                meta: { requiresAuth: false, roles: [] },
                component: () =>
                    import ("@/views/Auth/Login.vue"),
            },
            {
                path: "/registrar",
                name: "Register",
                meta: { requiresAuth: false, roles: [] },
                component: () =>
                    import ("@/views/Auth/Register.vue"),
            },
            {
                path: "/password/restablecer",
                name: "PasswordRestore",
                meta: { requiresAuth: false, roles: [] },
                component: () =>
                    import ("@/views/Auth/PasswordRestore.vue"),
            },
            {
                path: "/password/actualizar/:token",
                name: "PasswordUpdate",
                meta: { requiresAuth: false, roles: [] },
                component: () =>
                    import ("@/views/Auth/PasswordUpdate.vue"),
            },
        ],
    },
    // Profiles
    {
        name: "Perfil",
        path: "/perfil",
        meta: { requiresAuth: true, required_roles: [1, 6] },
        component: () =>
            import ("@/views/Profiles/Profile.vue"),
        children: [
            // Profile Admin
            {
                name: "PerfilAdmin",
                path: "admin",
                redirect: { name: "SalesOrderIndex" },
                meta: { requiresAuth: true, required_roles: [1] },
                component: () =>
                    import ("@/views/Profiles/Admin/Profile.vue"),
                children: [
                    // Sales Order
                    {
                        path: "ordenventa",
                        name: "SalesOrderIndex",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/SalesOrder/Index.vue"
                            ),
                    },
                    {
                        path: "ordenventa/crear",
                        name: "SalesOrderCreate",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/SalesOrder/Create.vue"
                            ),
                    },
                    {
                        path: "ordenventa/:id",
                        name: "SalesOrderShow",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/SalesOrder/Show.vue"
                            ),
                    },
                    {
                        path: "lprecio",
                        name: "PriceList",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/PriceList/Index.vue"
                            ),
                    },
                    {
                        path: "lprecio/:id",
                        name: "PriceListShow",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/PriceList/Show.vue"
                            ),
                    },
                    // Customers
                    {
                        path: "cliente",
                        name: "CustomerIndex",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/Customer/Index.vue"
                            ),
                    },

                    {
                        path: "cliente/:id",
                        name: "CustomerShow",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/Customer/Show.vue"
                            ),
                    },
                    // Articles
                    {
                        path: "articulos",
                        name: "ArticleIndex",
                        meta: { requiresAuth: true, required_roles: [1] },
                        component: () =>
                            import (
                                "@/views/Profiles/Admin/Article/Index.vue"
                            ),
                    },
                ],
            },
            // Profile Customer
            {
                name: "PerfilCliente",
                path: "cliente",
                redirect: { name: "PurchasesIndex" },
                meta: { requiresAuth: true, required_roles: [6] },
                component: () =>
                    import ("@/views/Profiles/Customer/Profile.vue"),
                children: [{
                        path: "compra",
                        name: "PurchasesIndex",
                        meta: { requiresAuth: true, required_roles: [6] },
                        component: () =>
                            import (
                                "@/views/Profiles/Customer/PurchaseOrder/Index.vue"
                            ),
                    },
                    {
                        path: "compra/crear",
                        name: "PurchaseCreate",
                        meta: { requiresAuth: true, required_roles: [6] },
                        component: () =>
                            import (
                                "@/views/Profiles/Customer/PurchaseOrder/Create.vue"
                            ),
                    },
                    {
                        path: "compra/:id",
                        name: "PurchaceShow",
                        meta: { requiresAuth: true, required_roles: [6] },
                        component: () =>
                            import (
                                "@/views/Profiles/Customer/PurchaseOrder/Show.vue"
                            ),
                    },
                ],
            },
        ],
    },
    // Store
    {
        path: "/tienda",
        name: "Store",
        meta: { requiresAuth: false, roles: [], denied_roles: [1] },
        redirect: { name: "StoreIndex" },
        component: () =>
            import ("@/views/Store.vue"),
        children: [{
                path: "",
                name: "StoreIndex",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Home.vue"),
            },
            {
                path: "articulo/:id",
                name: "ArticleShow",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Article/Show.vue"),
            },
            {
                path: "producto/:id",
                name: "PrductShow",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Product/Show.vue"),
            },
            {
                path: "seccion/:id",
                name: "SectionShow",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Section/Show.vue"),
            },
            {
                path: "busqueda",
                name: "Search",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Search.vue"),
            },
            {
                path: "carrito",
                name: "CartShow",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Cart/Cart.vue"),
            },
            {
                path: "checkout",
                name: "Checkout",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Cart/Checkout.vue"),
            },
            // Pages
            {
                path: "vinilicas",
                name: "Vinilicas",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Pages/Categories/Vinilicas.vue"),
            },
            {
                path: "aerosoles",
                name: "Aerosoles",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Pages/Categories/Aerosoles.vue"),
            },
            {
                path: "impermeabilizantes",
                name: "Impermeabilizantes",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import (
                        "@/views/Pages/Categories/Impermeabilizantes.vue"
                    ),
            },
            {
                path: "esmlates",
                name: "Esmaltes",
                meta: { requiresAuth: false, roles: [], denied_roles: [1] },
                component: () =>
                    import ("@/views/Pages/Categories/Esmaltes.vue"),
            },
        ],
    },
];

const router = new VueRouter({
    // mode: "history",
    // base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    if (store.state.authenticated) {
        var user_roles = store.state.acount.rols_ids;
    }

    if (to.name == "Index") {
        if (store.state.authenticated) {
            if (user_roles.includes(1)) {
                return next({ name: "SalesOrderIndex" });
            }

            if (user_roles.includes(6)) {
                return next({ name: "Store" });
            }
        }

        return next({ name: "Login" });
    }

    if (["Index", "Login", "Register", "PasswordRestore"].includes(to.name)) {
        if (store.state.authenticated) {
            if (["Index", "Login"].includes(to.name)) {
                if (user_roles.includes(1)) {
                    return next({ name: "PerfilAdmin" });
                }

                if (user_roles.includes(6)) {
                    return next({ name: "PerfilCliente" });
                }
            }

            return next({ name: from.name });
        }
    }

    if (to.meta.requiresAuth) {
        if (store.state.authenticated) {
            if (to.meta.required_roles.length) {
                if (!to.meta.required_roles.some((rol) =>
                        user_roles.includes(rol)
                    )) {
                    return next({ name: "Error", params: { code: 403 } });
                }
            }
        } else {
            return next({ name: "Login" });
        }
    }

    if (to.meta.denied_roles && store.state.authenticated) {
        if (to.meta.denied_roles.some((rol) => user_roles.includes(rol))) {
            return next({ name: "Error", params: { code: 403 } });
        }
    }

    return next();
});

export default router;